// extracted by mini-css-extract-plugin
export default {"badge":"NavbarBadge_badge__wC0ML"};